<template>
    <div>
        <div class="banner-show">
            <div class="cover">
                <van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
                    <van-swipe-item v-for="(item,key,index) in swiperImg" :key="index">
                    <img :src="item.image" alt="">
                    </van-swipe-item>
                </van-swipe>
            </div>
		</div>
        <img src="@/assets/images/cec2023/coming_soon.jpg">
    </div>
</template>

<script>
import {ButtonDetail,MeetingsCarousel} from '../../config/interface.js'
export default {
    data(){
        return{
            swiperImg:[]
        }
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
        this.getMeetingCarousel();
    },
    methods:{
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
        //会议轮播
        getMeetingCarousel(){
            const url=MeetingsCarousel;
            let params={
                meeting_id:348
            }
            const method='POST';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    this.swiperImg=data
                }
            })
        },
    }
}
</script>

<style scoped>
img{
    width: 100%;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/pages/cec2023/toContinue.vue